import React, { useState, useEffect } from 'react';
import { Button, Box, Typography, TextField } from '@mui/material';
import axios from 'axios';

const YouTubeLinksManager = () => {
  const [links, setLinks] = useState([]);
  const [newUrl, setNewUrl] = useState('');
  const token = localStorage.getItem('token');

  const fetchLinks = () => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/youtube`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setLinks(res.data))
      .catch((err) => console.error('Fetch error:', err));
  };

  useEffect(() => {
    fetchLinks();
  }, []);

  const addLink = () => {
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/youtube`,
        { url: newUrl },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        setNewUrl('');
        fetchLinks();
      })
      .catch((err) => console.error('Add error:', err));
  };

  const deleteLink = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/youtube/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => fetchLinks())
      .catch((err) => console.error('Delete error:', err));
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>YouTube Links</Typography>
      <TextField
        value={newUrl}
        onChange={(e) => setNewUrl(e.target.value)}
        placeholder="Enter YouTube URL"
        variant="outlined"
        size="small"
        sx={{ mr: 1, width: '60%' }}
      />
      <Button onClick={addLink} variant="contained">Add</Button>

      <ul style={{ marginTop: 20 }}>
        {links.map((link) => (
          <li key={link.id}>
            <a href={link.url} target="_blank" rel="noopener noreferrer">{link.url}</a> - {link.created_by}
            <Button
              variant="text"
              color="error"
              onClick={() => deleteLink(link.id)}
              sx={{ ml: 1 }}
            >
              Delete
            </Button>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default YouTubeLinksManager;
